import { configureStore } from "@reduxjs/toolkit";
import { injectStore } from "../api";

import authSlice from "./slices/auth/slice";
import adminSlice from "./slices/admin/slice";
import setsSlice from "./slices/sets/slice";
import ordersSlice from "./slices/orders/slice";
import contactSlice from "./slices/contact/slice";
import workshopsSlice from "./slices/workshops/slice";

const store = configureStore({
  reducer: {
    authInfo: authSlice,
    adminInfo: adminSlice,
    sets: setsSlice,
    orders: ordersSlice,
    contact: contactSlice,
    workshops: workshopsSlice,
  },

  devTools: false,
});

injectStore(store);

export default store;
